import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import dateformat from "dateformat";
import CalendarCheckFillIcon from "remixicon-react/CalendarEventFillIcon";
import { Button } from "$components";
import JTooltip from "$components/JTooltip/JTooltip";
import { DEFAULT_DATE_FORMAT } from "$utils/utils";
import ProjectStatusBadge from "../../ProjectStatusBadge";
import { useStyles } from "../styles";
import { ProjectDetailsLogic } from "../types";

type ProjectHeaderProps = Pick<
  ProjectDetailsLogic,
  | "project"
  | "isProjectDisabled"
  | "canEdit"
  | "handleSwitchToggle"
  | "dockyards"
  | "setModalDeleteOpen"
  | "isLoading"
>;

export default function ProjectHeader({
  project,
  isProjectDisabled,
  canEdit,
  handleSwitchToggle,
  dockyards,
  setModalDeleteOpen,
  isLoading,
}: ProjectHeaderProps) {
  const clasx = useStyles();

  return (
    <div
      style={{
        display: "flex",
        marginLeft: 18,
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <div className={clasx.customHeader}>
        <div className={clasx.calendar}>
          <CalendarCheckFillIcon className={clasx.calendarIcon} />
          Créé le{" "}
          {(project as any)?.createdAt &&
            dateformat(
              new Date((project as any)?.createdAt),
              DEFAULT_DATE_FORMAT
            )}
        </div>
        <div className={clasx.statusBadge}>
          <ProjectStatusBadge status={project?.status} />
        </div>
        <JTooltip
          title={
            project?.companyDisable
              ? "Le projet est inactif car l'entreprise associée est inactive"
              : ""
          }
        >
          <FormControlLabel
            className={clasx.switchButton}
            control={
              <Switch
                checked={!isProjectDisabled}
                onChange={handleSwitchToggle}
                name="activeCompany"
                color="primary"
                disabled={!canEdit || project?.companyDisable || isLoading}
              />
            }
            label="Projet actif"
          />
        </JTooltip>
      </div>
      <Tooltip
        title={
          dockyards?.data.length > 0
            ? "Vous ne pouvez pas supprimer ce projet car il a des chantiers liés"
            : ""
        }
      >
        <span>
          <Button
            disabled={
              !canEdit || dockyards?.data.length > 0 || isProjectDisabled
            }
            style={{ marginRight: 40, marginTop: 20 }}
            onClick={() => setModalDeleteOpen(true)}
            className={[
              clasx.buttonDelete,
              dockyards?.data.length > 0 || isProjectDisabled ? "disabled" : "",
            ].join(" ")}
          >
            Supprimer le projet
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}
